import { render } from "./BDCountrySelector.vue?vue&type=template&id=fd3326f0&scoped=true"
import script from "./BDCountrySelector.vue?vue&type=script&lang=js"
export * from "./BDCountrySelector.vue?vue&type=script&lang=js"

import "./BDCountrySelector.vue?vue&type=style&index=0&id=fd3326f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3326f0"]])

export default __exports__